import React from 'react';
import { FormSection } from '@atlaskit/form';
import { EditCreateInvoiceGroup } from '@css-xp/base';
import { ADDITIONAL_INVOICE_RECIPIENT, ADDITIONAL_INVOICE_RECIPIENTS } from '@css-xp/ppc-constants';

interface InvoiceContactsStepProps {
  onUpdateAdminFieldsDirtyFlag: (flag: boolean) => void;
  defaultRecipients: string[];
  namePrefix?: string;
  validDomains?: string[] | null | undefined;
  isPartner?: boolean;
}

export const InvoiceContactsStep = ({
  onUpdateAdminFieldsDirtyFlag,
  defaultRecipients,
  namePrefix,
  validDomains,
}: InvoiceContactsStepProps) => {
  return (
    <FormSection>
      <div className="form-component-width" data-testId="Invoice contacts">
        <EditCreateInvoiceGroup
          recipients={defaultRecipients?.length > 0 ? defaultRecipients : ['']}
          updateAdminFieldsDirtyFlag={onUpdateAdminFieldsDirtyFlag}
          isRequired={false}
          placeholder={`Enter email address of the ${ADDITIONAL_INVOICE_RECIPIENT.toLowerCase()}`}
          helperMessage={`Manage the ${ADDITIONAL_INVOICE_RECIPIENTS.toLowerCase()} for this billing profile.`}
          title={ADDITIONAL_INVOICE_RECIPIENTS}
          namePrefix={namePrefix}
          validDomains={validDomains}
        />
        <hr className="recipient-border" />
      </div>
    </FormSection>
  );
};
